<template>
  <footer class="ann-footer">
    <div class="ann-footer-bg"></div>
    <div class="ann-footer-socials">
      <a
        v-show="$t('footer.jumpLink.fb')"
        class="ann-footer-social-icon ann-footer-social-icon--facebook-1"
        :href="$t('footer.jumpLink.fb')"
        target="_blank"
        aria-label="Facebook"
      ></a>
      <a
        v-show="$t('footer.jumpLink.fbGroup')"
        class="ann-footer-social-icon ann-footer-social-icon--facebook-2"
        :href="$t('footer.jumpLink.fbGroup')"
        target="_blank"
        aria-label="Facebook Group"
      ></a>
      <a
        v-show="$t('footer.jumpLink.dc')"
        class="ann-footer-social-icon ann-footer-social-icon--discord"
        :href="$t('footer.jumpLink.dc')"
        target="_blank"
        aria-label="Discord"
      ></a>
      <a
        v-show="$t('footer.jumpLink.yt')"
        class="ann-footer-social-icon ann-footer-social-icon--youtube"
        :href="$t('footer.jumpLink.yt')"
        target="_blank"
        aria-label="YouTube"
      ></a>
      <a
        v-show="$t('footer.jumpLink.tt')"
        class="ann-footer-social-icon ann-footer-social-icon--tiktok"
        :href="$t('footer.jumpLink.tt')"
        target="_blank"
        aria-label="TikTok"
      ></a>
    </div>
    <div class="ann-footer-links">
      <span>{{ $t('ann2026.footer.privacyPolicy') }}</span>
      <span class="ann-footer-divider"></span>
      <span>{{ $t('ann2026.footer.userAgreement') }}</span>
    </div>
    <div class="ann-footer-service">
      {{ $t('ann2026.footer.customerService') }}
    </div>
  </footer>
</template>

<style lang="less" scoped>
.ann-footer {
  position: relative;
  width: 752px;
  height: 350px;
  overflow: hidden;
  color: #fff;
}

.ann-footer-bg {
  position: absolute;
  top: 0;
  left: 1px;
  width: 750px;
  height: 350px;
  background: #000;
}

.ann-footer-socials {
  position: absolute;
  top: 48px;
  left: 0;
  width: 752px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 50px;
}

.ann-footer-social-icon {
  display: block;
  flex: 0 0 100px;
  width: 100px;
  height: 100px;
  background-position: center;
  background-repeat: no-repeat;

  &--facebook-1 {
    background-image: url('~@/assets/imgs/act/ann2026/footer/facebook-1.png');
    background-size: 100px 100px;
  }

  &--facebook-2 {
    background-image: url('~@/assets/imgs/act/ann2026/footer/facebook-2.png');
    background-size: 100px 100px;
  }

  &--discord {
    background-image: url('~@/assets/imgs/act/ann2026/footer/discord.png');
    background-size: 100px 100px;
  }

  &--youtube {
    background-image: url('~@/assets/imgs/act/ann2026/footer/youtube.png');
    background-size: 100px 75px;
  }

  &--tiktok {
    background-image: url('~@/assets/imgs/act/ann2026/footer/tiktok.png');
    background-size: 100px 100px;
  }
}

.ann-footer-links {
  position: absolute;
  top: 198px;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 48px;
  color: #777;
  font-size: 22px;
  line-height: 30px;
  white-space: nowrap;
}

.ann-footer-divider {
  width: 1px;
  height: 28px;
  background: #777;
}

.ann-footer-service {
  position: absolute;
  top: 249px;
  left: 26px;
  width: 700px;
  color: #fff;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
}
</style>
